/**
 * top
 */

'use strict';
import AppTop from '@/_modules/app_top';

document.addEventListener('DOMContentLoaded', () => {
  new AppTop();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});
